import { useContext } from "react";

import { TypographyH2, TypographyP } from "../Typography";
import RouteTestingMap from "./RouteTestingMap";
import { LanguageContext } from "../languageContext";
import { HeaderIds } from "src/helpers/uiConstants";
import { isMobile } from "src/helpers/mapConstants";
import LazyScroll from "../ui/LazyScroll";

export default function RouteTestingMapWrapper() {
  const { translate } = useContext(LanguageContext);

  return (
    <div>
      <TypographyH2
        id={HeaderIds.testYourOwnRouteHeader}
        textId="testRouteHeader"
      />
      <TypographyP textId="testRouteDescription" />
      <TypographyP className="font-bold" textId="toUseTheTool" />
      <ol className="list-decimal ml-6 mb-8">
        <li>{translate("chooseBlockStart")}</li>
        <li>{translate("chooseBlockEnd")}</li>
        <li>{translate("compareTravelTimes")}</li>
      </ol>
      <LazyScroll height={isMobile ? "995px" : "768px"}>
        <RouteTestingMap />
      </LazyScroll>
    </div>
  );
}
